var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseEmissionH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 682.667,
    height: 682.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-73.546l-5.411-4.82h-46L-129.875 0h-73.547c-7.746 0-14.086-6.338-14.086-14.085v-203.422c0-7.747 6.34-14.086 14.086-14.086H0c7.747 0 14.086 6.339 14.086 14.086v203.422C14.086-6.338 7.747 0 0 0",
    style: {
      fill: "#fbc481",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(428.873 504.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v203.421c0 7.748 6.339 14.086 14.086 14.086h-50.153c-7.746 0-14.086-6.338-14.086-14.086V0c0-7.748 6.34-14.086 14.086-14.086h50.153C6.339-14.086 0-7.748 0 0",
    style: {
      fill: "#dd9973",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(261.519 286.992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-89.18c0-3.916 4.348-6.267 7.624-4.123l17.843 11.676a4.923 4.923 0 0 0 5.395 0l17.842-11.676c3.276-2.144 7.625.207 7.625 4.123V0z",
    style: {
      fill: "#d6865f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(298.998 504.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-28.164v-89.18c0-3.916 4.348-6.267 7.624-4.122l17.843 11.675A4.913 4.913 0 0 0 0-80.822z",
    style: {
      fill: "#b97359",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(327.162 504.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-50.885c-7.208 0-13.052-5.844-13.052-13.053v-51.822c0-7.208 5.844-13.052 13.052-13.052H0c7.209 0 13.053 5.844 13.053 13.052v51.822C13.053-5.844 7.209 0 0 0",
    style: {
      fill: "#ffeddc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(304.604 377.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v51.822c0 7.209 5.844 13.053 13.053 13.053h-38.495c-7.208 0-13.052-5.844-13.052-13.053V0c0-7.208 5.844-13.052 13.052-13.052h38.495C5.844-13.052 0-7.208 0 0",
    style: {
      fill: "#fcd5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(279.162 312.748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-11.189 8.002-26.649 5.277-34.529-6.085l-45.189-65.161a13.984 13.984 0 0 0-2.011-2.284l-1.434-1.188 2.622-2.622h12.145L8.271-27.862l2.212 4.671C10.695-14.75 7.045-5.037 0 0",
    style: {
      fill: "#ffcebe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(456.478 237.624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a24.914 24.914 0 0 0 6.088 6.159C-5.094 14.067-20.478 11.326-28.333 0l-45.188-65.16a13.948 13.948 0 0 0-2.012-2.284l-1.434-1.189 2.622-2.622h12.146l23.141 14.935z",
    style: {
      fill: "#ffb1a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(450.282 231.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.74 11.732-23.643 14.652-35.056 6.61l-64.046-45.124a14.535 14.535 0 0 0-9.814-2.582l-46.868 4.667c-.332.033-.354.518-.024.57 11.699 1.861 21.253 11.216 22.752 23.519 1.772 14.538-8.378 27.85-22.927 30.074L-266.1 34.571a48.76 48.76 0 0 1-35.448-8.325l-58.84-41.457-3.241-11.639 58.333-83.534h12.318a154.107 154.107 0 0 0 78.405 20.356l99.225-1.209A79.335 79.335 0 0 1-67.69-76.799l60.797 42.836C4.072-26.237 7.372-11.175 0 0",
    style: {
      fill: "#ffdecf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(489.045 203.324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a14.588 14.588 0 0 0 3.558 20.274l54.586 38.459a48.585 48.585 0 0 0 7.651 4.399L40.11 67.059a48.76 48.76 0 0 1-35.448-8.326l-58.84-41.456-3.241-11.639L.914-77.896h12.318a154.343 154.343 0 0 0 31.63 13.652z",
    style: {
      fill: "#ffcebe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(182.835 170.836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-81.48 115.037c-3.553 5.016-10.551 6.165-15.633 2.566l-23.769-16.836V90.565l86.33-119.334 8.015-3.665 23.769 16.836C2.313-12 3.553-5.016 0 0",
    style: {
      fill: "#dbedff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(202.968 83.197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.916 16.823c-3.553 5.016-10.551 6.165-15.633 2.566L-51.317 2.553V-7.649l13.727-18.976z",
    style: {
      fill: "#b5dcff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(133.403 181.411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-58.011-41.089c-5.183-3.671-6.505-10.713-2.952-15.728l81.481-115.037c3.552-5.016 10.633-6.106 15.816-2.436l58.011 41.089z",
    style: {
      fill: "#7fb3fa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(82.086 183.964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.553 5.016-1.596 12.508 4.371 16.734l29.18 20.668-18.349 25.905-58.011-41.089c-5.183-3.671-6.504-10.713-2.952-15.728L35.72-108.547c3.552-5.016 10.634-6.106 15.816-2.435l18.027 12.768z",
    style: {
      fill: "#64a6f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(66.884 120.657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h31.467",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(263.365 326.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h31.467",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(263.365 351.209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-50.885c-7.209 0-13.053-5.844-13.053-13.053v-51.822c0-7.208 5.844-13.052 13.053-13.052H0c7.209 0 13.053 5.844 13.053 13.052v51.822C13.053-5.844 7.209 0 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(304.541 377.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-58.011-41.089c-5.182-3.671-6.504-10.713-2.951-15.728l81.481-115.037c3.552-5.016 10.633-6.106 15.816-2.436l58.011 41.089z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(82.022 183.964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-81.48 115.037c-3.553 5.016-10.552 6.165-15.633 2.566l-23.77-16.836 94.346-133.201 23.769 16.836C2.313-12 3.553-5.016 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(202.904 83.197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.479-.346 6.969.57 9.823 2.581l64.046 45.125a24.747 24.747 0 0 0 12.972 4.498c.213 8.442-3.439 18.155-10.483 23.192-11.19 8.001-26.649 5.277-34.529-6.085L-3.36 4.15C-4.308 2.785-5.486 1.632-6.805.678Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(380.057 162.228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-51.646 4.125",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(339.376 166.279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.739 11.732-23.642 14.652-35.055 6.61l-64.046-45.124a14.535 14.535 0 0 0-9.814-2.582l-49.637 4.942c12.921.73 23.882 10.562 25.496 23.814 1.773 14.538-8.377 27.85-22.926 30.074l-110.117 16.837a48.76 48.76 0 0 1-35.448-8.325l-58.841-41.457 67.411-95.173a154.105 154.105 0 0 0 78.405 20.356l99.225-1.209A79.33 79.33 0 0 1-67.69-76.799l60.798 42.836C4.073-26.237 7.373-11.175 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(488.98 203.324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h84.211c7.746 0 14.086 6.339 14.086 14.086v203.422c0 7.747-6.34 14.085-14.086 14.085h-203.422c-7.747 0-14.086-6.338-14.086-14.085V14.086c0-7.747 6.339-14.086 14.086-14.086H-35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(344.599 272.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v25.681h-56.329v-89.18c0-3.917 4.349-6.267 7.625-4.123l17.842 11.676a4.927 4.927 0 0 0 5.395 0l17.843-11.676C-4.348-69.766 0-67.416 0-63.499V-35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(355.263 478.818)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseEmissionH);
export default __webpack_public_path__ + "static/media/UseEmission-h.efd0428d59bad55f878ae77d8b6142cf.svg";
export { ForwardRef as ReactComponent };